import { createInsuranceProductPreset } from '../common/productPresetFactory'

const COPY_BY_PRESET = {
  default: {
    heroTitle: '노후 자금의 목적과 수령 구조를 기준으로 연금보험을 검토합니다',
    heroSubtitle: '납입 기간, 수령 시점, 장기 유지 가능성을 함께 확인해 상담 방향을 정리합니다.',
    formTitle: '연금보험 상담 신청',
  },
  'clean-form': {
    heroTitle: '연금보험, 시작 전 꼭 알아야 할 구조를 간단히 안내해드립니다',
    heroSubtitle: '납입과 수령 흐름을 먼저 정리하고 현재 상황에 맞는 연금 방향을 상담합니다.',
    formTitle: '연금 구조 상담',
  },
  'hanwha-sections': {
    heroTitle: '노후 준비 목적에 맞는 연금 방향을 한눈에 정리해드립니다',
    heroSubtitle: '수익률보다 먼저 확인해야 할 준비 목적, 납입 여력, 수령 구조를 정리합니다.',
    formTitle: '연금 방향 상담 신청',
  },
  'basic-template-4': {
    heroTitle: '수익보다 중요한 연금 설계의 기준부터 확인하세요',
    heroSubtitle: '노후 준비의 출발점이 되는 기준을 먼저 확인하고 내게 맞는 방향을 안내해드립니다.',
    formTitle: '연금 기준 점검',
  },
  'basic-template-5': {
    heroTitle: '장기 유지까지 고려한 연금보험 전략을 함께 설계하세요',
    heroSubtitle: '준비 목적과 수령 전략을 함께 점검해 오래 유지할 수 있는 연금 방향을 안내해드립니다.',
    formTitle: '1:1 연금 상담',
  },
}

export function getProductPensionPreset(presetKey = 'default') {
  const copy =
    COPY_BY_PRESET[presetKey]
    || (presetKey === 'lead-gen-fullbleed' ? COPY_BY_PRESET['hanwha-sections'] : undefined)
    || COPY_BY_PRESET.default
  return createInsuranceProductPreset('PRODUCT_PENSION', copy, presetKey)
}
